import React from "react";
import { LegalPage, H2, P, UL } from "./LegalPage";

export const TermsOfService = () => (
  <LegalPage
    eyebrow="Legal"
    title="Terms of Service"
    description="Kerala Speaks platform terms — acceptable use, moderation rights, and liability."
    canonical="/terms"
    lastUpdated="May 2026"
    testId="terms-page"
  >
    <P>
      Welcome to Kerala Speaks. By using the platform you agree to these terms. They exist to keep the space respectful, useful, and safe for every citizen who participates.
    </P>

    <H2>1. Who we are</H2>
    <P>
      Kerala Speaks ("we", "us") is an independent, non-partisan civic platform. It is not affiliated with any political party, candidate, or government organisation.
    </P>

    <H2>2. Eligibility</H2>
    <P>
      You must be 13 years or older to participate. By posting on Kerala Speaks you confirm you meet that age requirement and that you are participating voluntarily.
    </P>

    <H2>3. Acceptable use</H2>
    <P>You agree NOT to use Kerala Speaks to:</P>
    <UL>
      <li>Post abuse, hate speech, threats, slurs, or violent language.</li>
      <li>Post defamatory, deceptive, or knowingly false information.</li>
      <li>Harass, dox, or target any individual, community, or group.</li>
      <li>Promote political parties, candidates, or campaign material.</li>
      <li>Post spam, advertising, affiliate links, or repetitive content.</li>
      <li>Attempt to manipulate poll results through bots, scripts, or coordinated abuse.</li>
      <li>Impersonate another person or misrepresent your affiliation.</li>
      <li>Probe, scrape, or attack the platform's infrastructure.</li>
    </UL>

    <H2>4. Your content</H2>
    <P>
      You keep ownership of what you post. By submitting content you grant Kerala Speaks a non-exclusive, royalty-free licence to display, aggregate, anonymise, and publish your content (or excerpts of it) as part of public civic reports, social media posts, and platform features. We will never tie your displayed content to your real-world identity without your explicit consent.
    </P>

    <H2>5. Moderation</H2>
    <UL>
      <li>We reserve the right to moderate, remove, or hide any content that violates these terms or community guidelines.</li>
      <li>We use a combination of automated tools and manual review.</li>
      <li>Moderation decisions are made in good faith to keep the platform respectful and constructive.</li>
      <li>If your content was removed and you believe it shouldn't have been, you can appeal by emailing <a className="underline" href="mailto:keralaspeaks7@gmail.com">keralaspeaks7@gmail.com</a>.</li>
    </UL>

    <H2>6. No professional advice</H2>
    <P>
      Content on Kerala Speaks is for civic, informational, and discussion purposes. It does not constitute legal, medical, financial, or professional advice.
    </P>

    <H2>7. Disclaimers</H2>
    <P>
      The platform is provided "as is" without warranties of any kind. Poll results, aggregate insights, and citizen-submitted content represent the views of the participants and not the views of Kerala Speaks. We do not guarantee uninterrupted availability, freedom from errors, or completeness of any information shown.
    </P>

    <H2>8. Limitation of liability</H2>
    <P>
      To the maximum extent permitted by applicable law, Kerala Speaks and its operators are not liable for any indirect, incidental, consequential, or punitive damages arising from your use of the platform. Direct liability, if any, is limited to ₹1,000.
    </P>

    <H2>9. Indemnity</H2>
    <P>
      You agree to indemnify Kerala Speaks against any claim arising from content you post or from your violation of these terms.
    </P>

    <H2>10. Termination</H2>
    <P>
      We may suspend or terminate access to anyone who repeatedly violates these terms or community guidelines, or who uses the platform in a way that threatens its safety or integrity. You may stop using the platform at any time.
    </P>

    <H2>11. Changes</H2>
    <P>
      We may update these terms from time to time. The "Last updated" date at the top of this page will reflect the most recent change. Continued use of the platform after an update constitutes acceptance of the new terms.
    </P>

    <H2>12. Governing law</H2>
    <P>
      These terms are governed by the laws of India. Any disputes will be resolved in the courts of Kerala.
    </P>

    <H2>13. Contact</H2>
    <P>
      Questions about these terms? Write to <a className="underline" href="mailto:keralaspeaks7@gmail.com">keralaspeaks7@gmail.com</a>.
    </P>
  </LegalPage>
);

export default TermsOfService;
